import axiosInstance from "../services/AxiosInstance";

export function getProjectsApi({ page, search, filters, limit }) {
  return axiosInstance.get(
    `projects?page=${page}&search=${search}&filters=${filters.join(",")}&limit=${limit}`
  );
}

export function getProjectByIdApi(id) {
  return axiosInstance.get(`projects/${id}`);
}

export function updateProjectStatusApi(id, status) {
  return axiosInstance.put(`projects/change-status/${id}`, { status });
}

export function deleteProjectApi(id) {
  return axiosInstance.delete(`projects/${id}`);
}

export function getProjectCountsApi() {
  return axiosInstance.get(`projects/get-project-counts`);
}